<template>
<div v-if="!isMobile()" class="modal-card" style="text-align: -webkit-center;">
    <header class="modal-card-head">
        <div class="model-icon icon-watchlist">
            <img src="/img/noun_Eye_2037671.svg">
        </div>
        <button
            type="button"
            class="delete"
            @click="$parent.close()"
        />
    </header>
    <section class="modal-card-body">
        <div class="card-content">
            <!-- <div class="has-text-weight-bold is-size-4-tablet is-size-5-mobile">Enter new Watchlist name</div> -->
            <input v-model="newlistname" placeholder="Enter name" type="text" maxlength="40"
                   class="m-b-40 w-100 px-2" @input="newlistname=newlistname.trimStart()"/>
            <div>
                <a class="button is-primary" @click="createNewWatchlist">Create</a>
            </div>
        </div>
    </section>
</div>
<div v-else class="modal-card h-100">
    <header class="modal-card-head">
        <a class="btn-close" @click="$parent.close()">
            <b-icon  icon="close" size="is-medium" ></b-icon>
        </a>
    </header>
    <section class="modal-card-body">
        <div class="watchlist-head p-2 text-align-center is-uppercase mb-5">
            Add Watchlist
            <img class="pl-5" src="/img/Watchlist.png">
        </div>
        <div class="card-content">
            <!-- <div class="has-text-weight-bold is-size-4-tablet is-size-5-mobile">Enter new Watchlist name</div> -->
            <input v-model="newlistname" placeholder="Enter name" type="text" maxlength="40"
                   class="m-b-40 w-100 px-2" @input="newlistname=newlistname.trimStart()"/>
            <div>
                <a class="button is-primary" @click="createNewWatchlist">Create</a>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import compositeMixin from "@/mixins/compositeMixin";
import axios from 'axios';
export default {
    name: "watchlist-modal",
    mixins: [compositeMixin],
    props: {
        fundId: {
            type: String,
            default: ''
        },
        isAddingAllFunds: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            newlistname: '',
        }
    },
    methods: {
        async createNewWatchlist() {
            if(this.newlistname !== '') {
                await axios.post("/watchlist", {
                    name: this.newlistname
                }).then((res) => {
                    if(res.status === 200) {
                        this.$toast.success('New Watchlist Added!')
                        this.$emit('create-watchlist')
                        this.$parent.close();
                        const { id, name } = res.data.data
                        if(id) {
                            this.fundId && this.addFund(id);
                            this.isAddingAllFunds && this.addFunds(id);
                        }
                        this.$store.commit("watchlist/SET_CURRENT_WATCHLIST", {
                            id,
                            name,
                            disabled: false,
                        });
                        this.$store.commit("watchlist/SET_SORTING1", {});
                        this.$store.commit("watchlist/SET_SORTING2", {});
                        if(this.$route.name !== "Watchlist") {
                            this.$router.push({name:"Watchlist"});
                        }
                    }
                    
                }).catch(err => {
                    this.$toast.error(err.response.data.message)
                    
                })
            }
            else {
                this.$toast.error('Watchlist name is empty!')
            }
            
        },
        addFund(watchlistId) {
            axios.post(`/watchlist/fund`,{
            fund_id: this.fundId,
            watchlist_ids: [watchlistId],
            isin: this.ISIN
            }).then(res => {
                if(res.status===200) {
                    this.$parent.close();
                }
            }).catch(err => {
                this.$toast.error(err.response.data.message)
            });
        },
        async addFunsToWatchlistByID(watchlistId, fundIDs, ISINs) {
            try {
                let res = await axios.post(`/watchlist/multi-fund`, {
                            watchlist_id: watchlistId,
                            fund_ids: fundIDs,
                            ISINs
                        })
                if(res.status === 200) {
                    this.$toast.success('Funds added successfully to watchlist!')
                    this.$parent.close();
                }
            } catch (error) {
                if(error.response.data.data.added) {
                    let fundText = error.response.data.data.added > 1 ? 'funds' : 'fund'
                    this.$toast.success(`${error.response.data.data.added} ${fundText} has been added successfully`)
                }
                this.$parent.close();
            }
            
        },
        async addFunds(watchlistId) {
            let fundIDs = [];
            let ISINs = [];
            let shortlist = this.$store.state.shortlist.fullshortlist
            shortlist.forEach(el=>{
                fundIDs.push(el.fund_id);
                ISINs.push(el.ISIN);
            })
            this.addFunsToWatchlistByID(watchlistId, fundIDs, ISINs)
        },
    }
}
</script>

<style>

</style>